import SavingsGoalWizard from './SavingsGoalWizard'

export default SavingsGoalWizard
